function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 61",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-277,-133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "matrix(1.61997,0,0,1.61997,162.468,117.77)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.994,
    y: 9.469,
    width: 37.038,
    height: 37.038,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.05257,0,0,1.05257,-231.412,-141.019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.901,169.572C316.545,169.572 317.897,170.925 317.897,172.57C317.897,174.214 316.545,175.574 314.901,175.574L294.902,175.574C293.258,175.574 291.899,174.214 291.899,172.57C291.899,170.925 293.258,169.572 294.902,169.572L314.901,169.572ZM304.899,150.572M304.899,150.572C299.93,150.572 295.899,154.601 295.899,159.57C295.899,162.162 295.887,165.347 294.672,168.591L315.131,168.591C313.916,165.347 313.904,162.162 313.904,159.57C313.904,154.601 309.867,150.572 304.899,150.572ZM301.885,148.556C301.885,146.911 303.238,145.558 304.883,145.558C306.528,145.558 307.879,146.911 307.879,148.556C307.879,149.052 307.745,149.516 307.527,149.931C306.688,149.701 305.809,149.568 304.899,149.568C303.977,149.568 303.089,149.703 302.24,149.939C302.021,149.522 301.885,149.055 301.885,148.556Z",
    style: {
      fillRule: "nonzero"
    }
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.fda5a5be.svg";
export { ForwardRef as ReactComponent };